export default __webpack_public_path__ + "static/media/y_wdt_c_6.08cc4db5.mp3";